import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';

export default class NotifyMeComponent extends Component {

  get COMPONENTNAME() {
    return 'NotifyMeComponent';
  }

  get SELECTORS() {
    return {
      notifyText: '[data-form-text]',
      notifyForm: '[data-js-form]',
      notifyFormInput:'[data-mail-box]',
      notifyFormBtn: '[data-notify-me-btn]',
      notifyConfirm: '[data-form-thanks]',
      notifyEmailError: '#emailError',
      notifySizeError: '#sizeError',
      productCodeInput: '#productCode',
      notifyCheck: '[data-notify-check]',
      buttonMsg: '.custom-button__message',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
    this.notifyText = this.$component.querySelector(this.SELECTORS.notifyText);
    this.notifyForm = this.$component.querySelector(this.SELECTORS.notifyForm);
    this.notifyFormBtn = this.$component.querySelector(
      this.SELECTORS.notifyFormBtn
    );
    this.notifyConfirm = this.$component.querySelector(
      this.SELECTORS.notifyConfirm
    );
    this.notifyFormInput = this.$component.querySelector(
      this.SELECTORS.notifyFormInput
    );
    this.notifyEmailError = this.$component.querySelector(
      this.SELECTORS.notifyEmailError
    );
    this.notifySizeError = this.$component.querySelector(
      this.SELECTORS.notifySizeError
    );
    this.productCodeInput = this.$component.querySelector(
      this.SELECTORS.productCodeInput
    );
    this.notifyCheck = this.$component.querySelector(
      this.SELECTORS.notifyCheck
    );
    this.buttonMsg = this.$component.querySelector(this.SELECTORS.buttonMsg);
  }

  bindEvents() {
    //handle show form
    this.$on(
      this.$customEvents.PRODUCT_EVENTS.notifyme,
      ({payload }) => {
      if (
        payload.productCode &&
        payload.productCode === this.$component.dataset.productCode
      ) {
        //open form endable button
        this.$component.classList.remove('--hidden');
        this.notifyText.classList.remove('--hidden');
        this.notifyEmailError.classList.add('--hidden');
        this.notifySizeError.classList.add('--hidden');
        this.notifyConfirm.classList.add('--hidden');
        this.notifyFormInput.classList.remove('--hidden');

        //change button content
        this.buttonMsg.classList.remove('--hidden');
        this.notifyCheck.classList.add('--hidden');

        //enable button
        this.notifyFormBtn.disabled = false;
      }
    });
    //handle close form
    this.$on(
      this.$customEvents.PRODUCT_EVENTS.notifymeclose,
      ({payload }) => {
      if (
        payload.productCode &&
        payload.productCode === this.$component.dataset.productCode
      ) {
        //hide and rest form, disable button
        this.$component.classList.add('--hidden');
        this.notifyFormInput.classList.remove('--hidden');
        this.notifyFormBtn.disabled = true;
        this.notifyEmailError.classList.add('--hidden');
        this.notifySizeError.classList.add('--hidden');
        this.notifyConfirm.classList.add('--hidden');
        this.notifyForm.reset();
      }
    });
    //handle size selection, change input value
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({ payload }) => {
      if (payload.baseProductCode === this.$component.dataset.productCode) {
        this.productCodeInput.value = payload.productCode;
      }
    });
  }

  // submit form
  bindSubmit() {
    this.notifyForm.addEventListener("submit", event => {
      event.preventDefault();
      event.stopPropagation();
      this.notifyEmailError.classList.add("--hidden");
      this.notifySizeError.classList.add("--hidden");

      const url = this.notifyForm.action;
      const data = new FormData(this.notifyForm);
      this.notifyFormBtn.classList.add("--loading");
      this.notifyFormBtn.disabled = true;

      fetch(url, {
        method: 'POST',
        body: data
      })
      .then(response => {
        if (response.ok) {
          return response.text().then(text => {
            //show success message
            this.notifyConfirm.classList.remove("--hidden");
            //hide input box
            this.notifyFormInput.classList.add("--hidden");
            this.notifyText.classList.add("--hidden");

            this.notifyFormBtn.classList.remove("--loading");

            //change button content
            this.buttonMsg.classList.add("--hidden");
            this.notifyCheck.classList.remove("--hidden");

            const productCode = data.get("productCode");
            if (productCode) {
              this.TrackingComponent.actions.notifyMe(productCode);
            }
          })
        } else {
          this.notifyFormBtn.disabled = false;
          //show error email empty
          if(!data.get("email") || data.get("email") === "") {
            this.notifyEmailError.classList.remove("--hidden");
          } else if(!data.get("size") || data.get("size") === "") {
            //show error size not selected
            this.notifySizeError.classList.remove("--hidden");
          } else {
            //generic error
            this.notifyEmailError.classList.remove("--hidden");
          }
          this.notifyFormBtn.classList.remove("--loading");
        }
      })
      .catch((error) => {
        this.notifyFormBtn.disabled = false;
        //show error email empty
        if(!data.get("email") || data.get("email") === "") {
          this.notifyEmailError.classList.remove("--hidden");
        } else if(!data.get("size") || data.get("size") === "") {
          //show error size not selected
          this.notifySizeError.classList.remove("--hidden");
        } else {
          //generic error
          this.notifyEmailError.classList.remove("--hidden");
        }
        this.notifyFormBtn.classList.remove("--loading");
      });
    });
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    this.bindSubmit();
  }
}
